import React from 'react'
import {Box, Grid} from "@mui/material";


const RightLogo = ()=>{
    return(
        <Grid container justifyContent="flex-start">
            <Box sx={{ flex: 1, alignContent:"start" }}>
                <img alt="logo" width={96} height={96} src={require("../assets/logos/zsk_logo.png")} />
            </Box>
        </Grid>
    )
}
export default RightLogo
